.speedbump-link {
	border-bottom: 1px dashed;
	text-decoration: none;
}

app-speedbump {
	app-dialog {
		.dialog {
			inline-size: unset;
			padding-bottom: 1.25rem;
			background-color: #fefefe;
			margin: 15% auto;
			border: 1px solid #888;
			width: 80%;
			max-width: 55vw;
			border: 1px solid #888;

			header {
				margin-block-end: 1rem;

				.logo-wrapper {
					display: flex;
					flex-direction: column;
					align-items: center;
					text-align: center;
					position: relative;
					padding-block: rem(20);
					padding-inline: rem(24);

					svg {
						@include svg-format(138px, 54px, $primary);
					}
				}

				h2 {
					display: flex;
					justify-content: center;
					align-items: center;
					text-align: center;
					margin: 0;
					background-color: $quinary;
					color: white;
					padding: 10px;
					font-size: rem(26);
					line-height: rem(27);
					font-weight: 700;
					font-family: $font-family-secondary;
					width: 100%;
				}

				p {
					padding-block-end: 0;
				}
			}

			.dialog__body {
				padding-block: rem(40) rem(20);
				padding-inline: rem(45);

				p {
					font-size: rem(16);
					line-height: rem(27);
					font-weight: 300;
					font-family: $font-family-secondary;
					color: $font-gray;
				}

				p:last-of-type {
					padding-block-end: 0;
				}
			}

			footer.speedbump-footer {
				border-top: none;
				background-color: #fefefe;
				margin: 0;
			}

			footer form {
				display: flex;
				justify-content: center;
				margin: 20px 0 30px;
				gap: 10px;
				padding-inline: rem(45);

				@include media-breakpoint-down(sm) {
					.btn {
						inline-size: 100%;
					}
				}
			}

			@include media-breakpoint-down(md) {
				margin: 5% auto;
				width: 90%;
				max-width: 90vw;

				header {
					h2 {
						font-size: rem(20);
						line-height: rem(22);
					}
				}

				.dialog__body {
					padding-block: rem(10) rem(10);
					padding-inline: rem(10);
					margin: 0 rem(10);

					p {
						font-size: rem(15);
						line-height: rem(22);
						margin-bottom: 0;
					}
				}

				footer form {
					flex-direction: column;
					align-items: center;

					.btn {
						width: 100%;
						max-width: 100%;
					}
				}
			}
		}
	}
}
